import * as React from "react";
import { TextField, Datagrid, List, BooleanField, FunctionField, useDataProvider, useNotify, useRefresh } from 'react-admin';
import Button from '@material-ui/core/Button';

const SetDefaultButton = ({ record }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    if (record.is_default) {
        return <span>Default</span>;
    }

    const handleClick = async (e) => {
        e.stopPropagation();
        try {
            await dataProvider.update('contract-templates', {
                id: record.id,
                data: { is_default: true },
                previousData: record,
            });
            notify('Default template updated', 'info');
            refresh();
        } catch (error) {
            console.error('Set default template error:', error);
            notify('Failed to update default template', 'warning');
        }
    };

    return <Button size="small" onClick={handleClick}>Set as Default</Button>;
};

export const ContractTemplateList = props => (
    <List {...props} bulkActionButtons={false} actions={null}>
        <Datagrid>
            <TextField source="name" />
            <BooleanField looseValue={true} source="is_default" label="Default" sortable={false} />
            <FunctionField label="" render={record => <SetDefaultButton record={record} />} />
        </Datagrid>
    </List>
);
